'use strict';

var useVisualState = require('../../motion/utils/use-visual-state.cjs');
var createRenderState = require('./utils/create-render-state.cjs');
var scrapeMotionValues = require('./utils/scrape-motion-values.cjs');

const useSVGVisualState = /*@__PURE__*/ useVisualState.makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValues.scrapeMotionValuesFromProps,
    createRenderState: createRenderState.createSvgRenderState,
});

exports.useSVGVisualState = useSVGVisualState;
//# sourceMappingURL=use-svg-visual-state.cjs.map
